import { getGroupPermissionFactory } from '../../../common/permissions/permissions.utils';
import { AccountsUsersPermissions } from './accounts-users.permissions';

export class AccountsUsersSpecializedRolesPermissions {
    static GroupName = `${AccountsUsersPermissions.GroupName}.SpecializedRoles`;

    static getPermissions = getGroupPermissionFactory(AccountsUsersSpecializedRolesPermissions.GroupName);

    static Permissions = {
        Assign: AccountsUsersSpecializedRolesPermissions.getPermissions('Assign'),
        Revoke: AccountsUsersSpecializedRolesPermissions.getPermissions('Revoke')
    };
}
